var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquaredCheck = function SvgSquaredCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 15c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h4c0 1.66 1.34 3 3 3s3-1.34 3-3zM4 0h14c2.21 0 4 1.79 4 4v14c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4m11.036 4.171a.5.5 0 0 1 .707 0l.707.708a.5.5 0 0 1 0 .707l-5.657 5.656-.707.707a.5.5 0 0 1-.707 0l-.707-.707-2.121-2.12a.5.5 0 0 1 0-.708l.707-.707a.5.5 0 0 1 .707 0l1.768 1.767z",
    clipRule: "evenodd"
  })));
};
export default SvgSquaredCheck;